/**
 * The consent notice's words. Kept here rather than in the locale files: the
 * content pages show the notice without loading the app or its translations.
 */
export interface NoticeCopy {
  /** Names the region for screen readers. */
  readonly label: string;
  readonly text: string;
  /** Link to the privacy page's section on it. */
  readonly details: string;
  /** The only button: agreeing is the one thing it does. */
  readonly accept: string;
}

export const NOTICE_COPY = {
  en: {
    label: 'Cookies',
    text: 'We count visits with Google Analytics cookies to see which pages help. Your videos still never leave your device.',
    details: 'Details',
    accept: 'Got it',
  },
  tr: {
    label: 'Çerezler',
    text: 'Hangi sayfaların işe yaradığını görmek için ziyaretleri Google Analytics çerezleriyle sayıyoruz. Videoların yine cihazından çıkmaz.',
    details: 'Ayrıntılar',
    accept: 'Anladım',
  },
} as const satisfies Record<string, NoticeCopy>;

export type NoticeLanguage = keyof typeof NOTICE_COPY;

/** `tr`, `tr-TR` → Turkish; everything else English (the primary language). */
export const noticeLanguage = (lang: string | undefined): NoticeLanguage => (lang?.toLowerCase().startsWith('tr') ? 'tr' : 'en');
